import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const routes = [
  {
    name: 'login',      // 登录
    path: '/',
    component: () => import('@/views/login/login.vue'),
  },
  {
    name: 'running',    // 运营管理.首页
    path: '/running',
    redirect: '/running/home',
    component: () => import('@/views/running/index.vue'),
    children: [
      {
        name: 'running.home',               // 运营管理.首页
        path: '/running/home',
        component: () => import('@/views/running/home/index.vue'),
      },
      // 应用管理
      {
        name: 'running.app.app.index',      // 运营管理.应用管理.应用.列表
        path: '/running/app/app/index',
        component: () => import('@/views/running/app/app/index/index.vue'),
      },
      {
        name: 'running.app.app.add',        // 运营管理.应用管理.应用.新增
        path: '/running/app/app/add',
        component: () => import('@/views/running/app/app/add/add.vue'),
      },
      {
        name: 'running.app.app.update',         // 运营管理.应用管理.应用.修改
        path: '/running/app/app/update',
        component: () => import('@/views/running/app/app/update/update.vue'),
      },
      // 应用配置
      {
        name: 'running.app.config.config',      // 运营管理.应用管理.应用配置.列表
        path: '/running/app/config/config',
        component: () => import('@/views/running/app/config/config/config.vue'),
      },
      // 渠道管理
      {
        name: 'running.app.channel.index',  // 运营管理.应用管理.推广渠道.列表
        path: '/running/app/channel/index',
        component: () => import('@/views/running/app/channel/index/index.vue'),
      },
      {
        name: 'running.app.channel.add',    // 运营管理.应用管理.推广渠道.新增
        path: '/running/app/channel/add',
        component: () => import('@/views/running/app/channel/add/add.vue'),
      },
      {
        name: 'running.app.channel.update',   // 运营管理.应用管理.推广渠道.修改
        path: '/running/app/channel/update',
        component: () => import('@/views/running/app/channel/update/update.vue'),
      },
      {
        name: 'running.app.channel.slot',   // 运营管理.应用管理.推广渠道.渠道位置
        path: '/running/app/channel/slot',
        component: () => import('@/views/running/app/channel/slot/slot.vue'),
      },
      {
        name: 'running.app.channel.rebate',  // 运营管理.应用管理.推广渠道.渠道返点
        path: '/running/app/channel/rebate',
        component: () => import('@/views/running/app/channel/rebate/rebate.vue'),
      },
      // 广告主管理
      {
        name: 'running.advertiser.advertiser.index',
        path: '/running/advertiser/advertiser/index',
        component: () => import('@/views/running/advertiser/advertiser/index/index.vue'),
      },
      {
        name: 'running.advertiser.advertiser.add',
        path: '/running/advertiser/advertiser/add',
        component: () => import('@/views/running/advertiser/advertiser/add/add.vue'),
      },
      {
        name: 'running.advertiser.advertiser.update',
        path: '/running/advertiser/advertiser/update',
        component: () => import('@/views/running/advertiser/advertiser/update/update.vue'),
      },
      // 积分墙管理
      {
        name: 'running.task.wall.index',      // 运营管理.任务广告.积分墙.列表
        path: '/running/task/wall/index',
        component: () => import('@/views/running/task/wall/index/index.vue'),
      },
      {
        name: 'running.task.wall.add',        // 运营管理.任务广告.积分墙.新增
        path: '/running/task/wall/add',
        component: () => import('@/views/running/task/wall/add/add.vue'),
      },
      {
        name: 'running.task.wall.update',     // 运营管理.任务广告.积分墙.修改
        path: '/running/task/wall/update',
        component: () => import('@/views/running/task/wall/update/update.vue'),
      },
      // 积分任务管理
      {
        name: 'running.task.itask.index',     // 运营管理.任务广告.积分任务.列表
        path: '/running/task/itask/index',
        component: () => import('@/views/running/task/itask/index/index.vue'),
      },
      {
        name: 'running.task.itask.add',       // 运营管理.任务广告.积分任务.新增
        path: '/running/task/itask/add',
        component: () => import('@/views/running/task/itask/add/add.vue'),
      },
      {
        name: 'running.task.itask.update',    // 运营管理.任务广告.积分任务.修改
        path: '/running/task/itask/update',
        component: () => import('@/views/running/task/itask/update/update.vue'),
      },
      // 审核任务管理
      {
        name: 'running.task.iaudit.index',     // 运营管理.任务广告.审核任务.列表
        path: '/running/task/iaudit/index',
        component: () => import('@/views/running/task/iaudit/index/index.vue'),
      },
      {
        name: 'running.task.iaudit.add',       // 运营管理.任务广告.审核任务.新增
        path: '/running/task/iaudit/add',
        component: () => import('@/views/running/task/iaudit/add/add.vue'),
      },
      {
        name: 'running.task.iaudit.update',    // 运营管理.任务广告.审核任务.修改
        path: '/running/task/iaudit/update',
        component: () => import('@/views/running/task/iaudit/update/update.vue'),
      },
      // 任务审核
      {
        name: 'running.task.approval.index',     // 运营管理.任务广告.任务审核.列表
        path: '/running/task/approval/index',
        component: () => import('@/views/running/task/approval/index/index.vue'),
      },
      {
        name: 'running.task.approval.approval',       // 运营管理.任务广告.任务审核.审核
        path: '/running/task/approval/approval',
        component: () => import('@/views/running/task/approval/approval/approval.vue'),
      },
      // 广告素材
      {
        name: 'running.ad.material.index',
        path: '/running/ad/material/index',
        component: () => import('@/views/running/ad/material/index/index.vue'),
      },
      {
        name: 'running.ad.material.add',
        path: '/running/ad/material/add',
        component: () => import('@/views/running/ad/material/add/add.vue'),
      },
      {
        name: 'running.ad.material.update',
        path: '/running/ad/material/update',
        component: () => import('@/views/running/ad/material/update/update.vue'),
      },
      // 广告
      {
        name: 'running.ad.ad.index',
        path: '/running/ad/ad/index',
        component: () => import('@/views/running/ad/ad/index/index.vue'),
      },
      {
        name: 'running.ad.ad.add',
        path: '/running/ad/ad/add',
        component: () => import('@/views/running/ad/ad/add/add.vue'),
      },
      {
        name: 'running.ad.ad.update',
        path: '/running/ad/ad/update',
        component: () => import('@/views/running/ad/ad/update/update.vue'),
      },
      // 广告位
      {
        name: 'running.ad.slot.index',
        path: '/running/ad/slot/index',
        component: () => import('@/views/running/ad/slot/index/index.vue'),
      },
      {
        name: 'running.ad.slot.add',
        path: '/running/ad/slot/add',
        component: () => import('@/views/running/ad/slot/add/add.vue'),
      },
      {
        name: 'running.ad.slot.update',
        path: '/running/ad/slot/update',
        component: () => import('@/views/running/ad/slot/update/update.vue'),
      },
      // 广告投放
      {
        name: 'running.ad.slot.service',
        path: '/running/ad/slot/service',
        component: () => import('@/views/running/ad/slot/service/service.vue'),
      },
      // 广告位资源
      {
        name: 'running.ad.resource.index',
        path: '/running/ad/resource/index',
        component: () => import('@/views/running/ad/resource/index/index.vue'),
      },
      {
        name: 'running.ad.resource.add',
        path: '/running/ad/resource/add',
        component: () => import('@/views/running/ad/resource/add/add.vue'),
      },
      {
        name: 'running.ad.resource.update',
        path: '/running/ad/resource/update',
        component: () => import('@/views/running/ad/resource/update/update.vue'),
      },
      {
        name: 'running.ad.resource.filter',
        path: '/running/ad/resource/filter',
        component: () => import('@/views/running/ad/resource/filter/filter.vue'),
      },
      // 测评
      {
        name: 'running.content.appraise.index',
        path: '/running/content/appraise/index',
        component: () => import('@/views/running/content/appraise/index/index.vue'),
      },
      {
        name: 'running.content.appraise.add',
        path: '/running/content/appraise/add',
        component: () => import('@/views/running/content/appraise/add/add.vue'),
      },
      {
        name: 'running.content.appraise.update',
        path: '/running/content/appraise/update',
        component: () => import('@/views/running/content/appraise/update/update.vue'),
      },
      {
        name: 'running.content.appraise.question',
        path: '/running/content/appraise/question',
        component: () => import('@/views/running/content/appraise/question/question.vue'),
      },
      {
        name: 'running.content.appraise.score',
        path: '/running/content/appraise/score',
        component: () => import('@/views/running/content/appraise/score/score.vue'),
      },
      {
        name: 'running.content.appraise.exhibit',
        path: '/running/content/appraise/exhibit',
        component: () => import('@/views/running/content/appraise/exhibit/exhibit.vue'),
      },
      {
        name: 'running.content.appraise.limit',
        path: '/running/content/appraise/limit',
        component: () => import('@/views/running/content/appraise/limit/limit.vue'),
      },
      // 测评模版
      {
        name: 'running.content.atemplet.index',
        path: '/running/content/atemplet/index',
        component: () => import('@/views/running/content/atemplet/index/index.vue'),
      },
      {
        name: 'running.content.atemplet.add',
        path: '/running/content/atemplet/add',
        component: () => import('@/views/running/content/atemplet/add/add.vue'),
      },
      {
        name: 'running.content.atemplet.update',
        path: '/running/content/atemplet/update',
        component: () => import('@/views/running/content/atemplet/update/update.vue'),
      },
      {
        name: 'running.content.atemplet.element',
        path: '/running/content/atemplet/element',
        component: () => import('@/views/running/content/atemplet/element/element.vue'),
      },
      // 知识
      {
        name: 'running.content.knowledge.index',
        path: '/running/content/knowledge/index',
        component: () => import('@/views/running/content/knowledge/index/index.vue'),
      },
      {
        name: 'running.content.knowledge.add',
        path: '/running/content/knowledge/add',
        component: () => import('@/views/running/content/knowledge/add/add.vue'),
      },
      {
        name: 'running.content.knowledge.update',
        path: '/running/content/knowledge/update',
        component: () => import('@/views/running/content/knowledge/update/update.vue'),
      },
      // 知识模版
      {
        name: 'running.content.ktemplet.index',
        path: '/running/content/ktemplet/index',
        component: () => import('@/views/running/content/ktemplet/index/index.vue'),
      },
      {
        name: 'running.content.ktemplet.add',
        path: '/running/content/ktemplet/add',
        component: () => import('@/views/running/content/ktemplet/add/add.vue'),
      },
      {
        name: 'running.content.ktemplet.update',
        path: '/running/content/ktemplet/update',
        component: () => import('@/views/running/content/ktemplet/update/update.vue'),
      },
      // 小说
      {
        name: 'running.content.book.index',
        path: '/running/content/book/index',
        component: () => import('@/views/running/content/book/index/index.vue'),
      },
      {
        name: 'running.content.book.add',
        path: '/running/content/book/add',
        component: () => import('@/views/running/content/book/add/add.vue'),
      },
      {
        name: 'running.content.book.update',
        path: '/running/content/book/update',
        component: () => import('@/views/running/content/book/update/update.vue'),
      },
      {
        name: 'running.content.book.chapter',
        path: '/running/content/book/chapter',
        component: () => import('@/views/running/content/book/chapter/chapter.vue'),
      },
      {
        name: 'running.content.book.limit',
        path: '/running/content/book/limit',
        component: () => import('@/views/running/content/book/limit/limit.vue'),
      },
      // 壁纸
      {
        name: 'running.content.wallpaper.index',
        path: '/running/content/wallpaper/index',
        component: () => import('@/views/running/content/wallpaper/index/index.vue'),
      },
      {
        name: 'running.content.wallpaper.add',
        path: '/running/content/wallpaper/add',
        component: () => import('@/views/running/content/wallpaper/add/add.vue'),
      },
      {
        name: 'running.content.wallpaper.update',
        path: '/running/content/wallpaper/update',
        component: () => import('@/views/running/content/wallpaper/update/update.vue'),
      },
      // 短剧
      {
        name: 'running.content.shortplay.index',
        path: '/running/content/shortplay/index',
        component: () => import('@/views/running/content/shortplay/index/index.vue'),
      },
      {
        name: 'running.content.shortplay.add',
        path: '/running/content/shortplay/add',
        component: () => import('@/views/running/content/shortplay/add/add.vue'),
      },
      {
        name: 'running.content.shortplay.update',
        path: '/running/content/shortplay/update',
        component: () => import('@/views/running/content/shortplay/update/update.vue'),
      },
      {
        name: 'running.content.shortplay.episode',
        path: '/running/content/shortplay/episode',
        component: () => import('@/views/running/content/shortplay/episode/episode.vue'),
      },
      {
        name: 'running.content.shortplay.limit',
        path: '/running/content/shortplay/limit',
        component: () => import('@/views/running/content/shortplay/limit/limit.vue'),
      },
      // 商品
      {
        name: 'running.commodity.store.index',
        path: '/running/commodity/store/index',
        component: () => import('@/views/running/commodity/store/index.vue'),
      },
      {
        name: 'running.commodity.choice.index',
        path: '/running/commodity/choice/index',
        component: () => import('@/views/running/commodity/choice/index.vue'),
      },
      // 应用报表
      {
        name: 'running.appstat.summary',      // 运营管理.任务广告.积分任务.列表
        path: '/running/appstat/summary',
        component: () => import('@/views/running/appstat/summary/index/index.vue'),
      },
      {
        name: 'running.appstat.visit',        // 运营管理.应用报表.访问统计
        path: '/running/appstat/visit',
        component: () => import('@/views/running/appstat/visit/index/index.vue'),
      },
      {
        name: 'running.appstat.user',        // 运营管理.应用报表.用户统计
        path: '/running/appstat/user',
        component: () => import('@/views/running/appstat/user/index/index.vue'),
      },
      {
        name: 'running.appstat.task',         // 运营管理.应用报表.任务统计
        path: '/running/appstat/task',
        component: () => import('@/views/running/appstat/task/index/index.vue'),
      },
      {
        name: 'running.appstat.ad',
        path: '/running/appstat/ad',
        component: () => import('@/views/running/appstat/ad/index/index.vue'),
      },
      {
        name: 'running.appstat.finance',      // 运营管理.应用报表.财务明细
        path: '/running/appstat/finance',
        component: () => import('@/views/running/appstat/finance/index/index.vue'),
      },
      {
        name: 'running.appstat.finance.add',   // 运营管理.应用报表.财务明细.增加收支记录
        path: '/running/appstat/finance/add',
        component: () => import('@/views/running/appstat/finance/add/add.vue'),
      },
      {
        name: 'running.appstat.finance.update',   // 运营管理.应用报表.财务明细.修改收支记录
        path: '/running/appstat/finance/update',
        component: () => import('@/views/running/appstat/finance/update/update.vue'),
      },
      {
        name: 'running.appstat.financial',   // 运营管理.应用报表.财务统计
        path: '/running/appstat/financial',
        component: () => import('@/views/running/appstat/financial/index/index.vue'),
      },
      {
        name: 'running.appstat.action',   // 运营管理.应用报表.动作统计
        path: '/running/appstat/action/action',
        component: () => import('@/views/running/appstat/action/action/action.vue'),
      },
      {
        name: 'running.appstat.action.subaction',   // 运营管理.应用报表.动作统计
        path: '/running/appstat/action/subaction',
        component: () => import('@/views/running/appstat/action/subaction/subaction.vue'),
      },
      // 快应用报表
      {
        name: 'running.luckystat.ad',
        path: '/running/luckystat/ad',
        component: () => import('@/views/running/luckystat/ad/index/index.vue'),
      },
      {
        name: 'running.luckystat.baidu',
        path: '/running/luckystat/baidu',
        component: () => import('@/views/running/luckystat/baidu/index/index.vue'),
      },
      {
        name: 'running.luckystat.lom',
        path: '/running/luckystat/lom',
        component: () => import('@/views/running/luckystat/lom/index/index.vue'),
      },
      {
        name: 'running.luckystat.lom.manual',
        path: '/running/luckystat/lom/manual',
        component: () => import('@/views/running/luckystat/lom/manual/manual.vue'),
      },
      {
        name: 'running.luckystat.snap',
        path: '/running/luckystat/snap',
        component: () => import('@/views/running/luckystat/snap/index/index.vue'),
      },
      {
        name: 'running.luckystat.loss',
        path: '/running/luckystat/loss',
        component: () => import('@/views/running/luckystat/loss/index/index.vue'),
      },
      {
        name: 'running.luckystat.target',
        path: '/running/luckystat/target',
        component: () => import('@/views/running/luckystat/target/index/index.vue'),
      },
      {
        name: 'running.luckystat.issue.index',
        path: '/running/luckystat/issue/index',
        component: () => import('@/views/running/luckystat/issue/index/index.vue'),
      },
      {
        name: 'running.luckystat.issue.add',
        path: '/running/luckystat/issue/add',
        component: () => import('@/views/running/luckystat/issue/add/add.vue'),
      },
      {
        name: 'running.luckystat.issue.batch',
        path: '/running/luckystat/issue/batch',
        component: () => import('@/views/running/luckystat/issue/batch/batch.vue'),
      },
      {
        name: 'running.luckystat.issue.update',
        path: '/running/luckystat/issue/update',
        component: () => import('@/views/running/luckystat/issue/update/update.vue'),
      },
      {
        name: 'running.luckystat.blacklist.index',
        path: '/running/luckystat/blacklist/index',
        component: () => import('@/views/running/luckystat/blacklist/index/index.vue'),
      },
      {
        name: 'running.luckystat.etask.index',
        path: '/running/luckystat/etask/index',
        component: () => import('@/views/running/luckystat/etask/index/index.vue'),
      },
      {
        name: 'running.luckystat.etask.add',
        path: '/running/luckystat/etask/add',
        component: () => import('@/views/running/luckystat/etask/add/add.vue'),
      },
      {
        name: 'running.luckystat.etask.update',
        path: '/running/luckystat/etask/update',
        component: () => import('@/views/running/luckystat/etask/update/update.vue'),
      },
      // 合作伙伴
      {
        name: 'running.partner.market.index',
        path: '/running/partner/market/index',
        component: () => import('@/views/running/partner/market/index/index.vue'),
      },
      {
        name: 'running.partner.snap.index',
        path: '/running/partner/snap/index',
        component: () => import('@/views/running/partner/snap/index/index.vue'),
      },
      {
        name: 'running.partner.issue.index',
        path: '/running/partner/issue/index',
        component: () => import('@/views/running/partner/issue/index/index.vue'),
      },
      {
        name: 'running.partner.issue.add',
        path: '/running/partner/issue/add',
        component: () => import('@/views/running/partner/issue/add/add.vue'),
      },
      {
        name: 'running.partner.issue.update',
        path: '/running/partner/issue/update',
        component: () => import('@/views/running/partner/issue/update/update.vue'),
      },
      {
        name: 'running.partner.issue.issue',
        path: '/running/partner/issue/issue',
        component: () => import('@/views/running/partner/issue/issue/issue.vue'),
      },
      {
        name: 'running.partner.oied.oied',
        path: '/running/partner/oied/oied',
        component: () => import('@/views/running/partner/oied/oied/oied.vue'),
      },
      // 操作员管理
      {
        name: 'running.operator.operator.index',
        path: '/running/operator/operator/index',
        component: () => import('@/views/running/operator/operator/index/index.vue'),
      },
      {
        name: 'running.operator.operator.add',
        path: '/running/operator/operator/add',
        component: () => import('@/views/running/operator/operator/add/add.vue'),
      },
      {
        name: 'running.operator.operator.update',
        path: '/running/operator/operator/update',
        component: () => import('@/views/running/operator/operator/update/update.vue'),
      },
      {
        name: 'running.operator.operator.appauthorize',
        path: '/running/operator/operator/appauthorize',
        component: () => import('@/views/running/operator/operator/appauthorize/appauthorize.vue'),
      },
      // 修改密码
      {
        name: 'running.operator.password',
        path: '/running/operator/password',
        component: () => import('@/views/running/operator/password/password.vue'),
      },
    ]
  },
]

export const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
